import apiService from './api.service';

class CommissionerService {
  async getCommissionerInfo() {
    try {
      const response = await apiService.post('/sections/get-by-uid', {UID: 'HOME-PROFILE-SECTION'}, {}, true);
     if (response && response.code === 1 && response.data) {
        // API returns array, get first item
        const commissionerData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        // Filter out unpublished content
        if (commissionerData && commissionerData.IsPublished === false) {
          return {
            success: false,
            data: null,
            message: 'Commissioner info is not published',
          };
        }
        
       return {
          success: true,
          data: commissionerData,
          message: response.message,
        };
      }
      
     return {
        success: false,
        data: null,
        message: response?.message || 'Failed to fetch commissioner info',
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.message || 'An error occurred while fetching commissioner info',
      };
    }
  }

  async getAboutContent() {
    try {
    const response = await apiService.post('/sections/get-by-uid', {UID: 'HOME-ABOUT-SECTION'}, {}, true);
     if (response && response.code === 1 && response.data) {
        // API returns array, get first item
        const aboutData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        // Filter out unpublished content
        if (aboutData && aboutData.IsPublished === false) {
          return {
            success: false,
            data: null,
            message: 'About content is not published',
          };
        }
        
       return {
          success: true,
          data: aboutData,
          message: response.message,
        };
      }
      
      return {
        success: false,
        data: null,
        message: response?.message || 'Failed to fetch about content',
      };
    } catch (error) {
      return {
        success: false,
        data: null,
        message: error.message || 'An error occurred while fetching about content',
      };
    }
  }

  transformCommissionerData(apiData) {
  const transformed = {
      name: apiData.SubTitle || apiData.Name || apiData.name,
      title: apiData.Title || apiData.title || apiData.Position,
      photo: apiData.Link || apiData.PhotoUrl || apiData.ImageUrl,
      bio: apiData.Description || apiData.Bio || apiData.bio,
    };
    
    return transformed;
  }

  transformAboutData(apiData) {
  const transformed = {
      title: apiData.Title || apiData.title,
      content: apiData.Description || apiData.description || apiData.Content,
      shortDescription: apiData.SubTitle || apiData.shortDescription,
    };
    
   return transformed;
  }
}

export default new CommissionerService();
